import React, { useEffect, useState } from "react";
import { useRouter } from "next/router";
import { get_cookie, strToLowerCase } from "../../utils";
import Brand from "../../components/brand";
import Category from "../../components/category";
import Fournotfour from "../../components/fournotfour";
import Home from "../../components/home";
import Vehicle from "../../components/vehicle";
import CmsDetails from "../../components/cmsDetail";
import BlogDetails from "../../components/blogDetail";
// import CookiesModal from "components/modals/cookiesModal";

const Index = ({
  data,
  features,
  brandList,
  categoryList,
  currentPage,
  brandBannerInfo,
  brandVehiclesData,
  categoryBannerInfo,
  categoryVehiclesData,
  vehicalDetailData,
  currentLocationId,
  cmsDetails,
  blogDetails,
}) => {
  const router = useRouter();
  const { slug } = router.query;
  const [isMobileApp, setIsMobileApp] = useState();

  let slug1 = "ca";
  let slug2 = "los-angeles";
  let slug3 = "rolls-royce";

  if (slug) {
    slug1 = strToLowerCase(slug[0]);
    if (slug[1]) {
      slug2 = strToLowerCase(slug[1]);
    }
    if (slug[2]) {
      slug3 = strToLowerCase(slug[2]);
    }
  }
 
  useEffect(() => {
    setIsMobileApp(get_cookie("is_mobile_app"));
  }, []);

  return (
    <>
      {(currentPage === "home" || currentPage === "dynamic") && (
        <Home
          data={data}
          features={features}
          brandList={brandList}
          categoryList={categoryList}
          slug1={slug1}
          slug2={slug2}
          slug3={slug3}
          currentLocationId={currentLocationId}
        />
      )}
      {currentPage === "brand" && (
        <Brand
          brandBannerInfo={brandBannerInfo}
          brandVehiclesData={brandVehiclesData}
          features={features}
          categoryList={categoryList}
          slug1={slug1}
          slug2={slug2}
          slug3={slug3}
          currentLocationId={currentLocationId}
        />
      )}
      {currentPage === "category" && (
        <Category
          categoryBannerInfo={categoryBannerInfo}
          categoryVehiclesData={categoryVehiclesData}
          features={features}
          slug1={slug1}
          slug2={slug2}
          slug3={slug3}
          currentLocationId={currentLocationId}
        />
      )}
      {currentPage === "vehicle" && (
        <Vehicle
          vehicalDetailData={vehicalDetailData}
          slug1={slug1}
          slug2={slug2}
          slug3={slug3}
        />
      )}

      {currentPage === "cms" && <CmsDetails data={cmsDetails} />}
      {currentPage === "blogdetail" && <BlogDetails data={blogDetails} />}

      {currentPage === "404" && <Fournotfour />}
      {/* {isMobileApp !== "yes" && <CookiesModal />} */}
    </>
  );
};

export default Index;
